<app-navbar
  [title]="this.products?.planName"
  [backLink]="'/I4UProducts'"
  [showBackButton]="true"
  [showLogout]="true"
>
</app-navbar>

<div class="slider">
  <img [src]="this.products?.productBannerUrl" class="slide" />
</div>

<div class="body">
  <mat-tab-group mat-stretch-tabs="false">
    <mat-tab label="{{ 'PRODUCT_PLAN_DETAIL.TAB_DETAILS' | translate }}">
      <ng-template mat-tab-label>
        <i class="fa-solid fa-circle-info"></i>
        <p>{{ 'PRODUCT_PLAN_DETAIL.TAB_DETAILS' | translate }}</p>
      </ng-template>

      <section class="section-plan-detail">
        <h1>{{ 'PRODUCT_PLAN_DETAIL.SUITABLE_FOR' | translate }}</h1>
        <div class="card plan-detail-card width-box">
          <div class="left">
            <img src="../../../assets/images/insurance-package.png" alt="" />
          </div>

          <div class="right">
            <h6>{{ this.products?.bestFor }}</h6>
          </div>
        </div>
      </section>

      <section class="section-plan-detail">
        <h1>{{ 'PRODUCT_PLAN_DETAIL.WHAT_IS_COVERED' | translate }}</h1>
        <div class="card plan-detail-card width-box">
          <div class="left">
            <i class="fa-solid fa-user-shield"></i>
          </div>

          <div class="right">
            <h6>{{ this.products?.coverageDesc }}</h6>
          </div>
        </div>
      </section>

      <section class="section-plan-detail">
        <h1>{{ 'PRODUCT_PLAN_DETAIL.TERMS_AND_PAYMENT' | translate }}</h1>

        <div class="big-card width-box">
          <div class="mini-card">
            <div class="box">
              <h6>{{ 'PRODUCT_PLAN_DETAIL.COVERAGE_AGE' | translate }}</h6>
              <div class="content">
                <i class="fa-solid fa-circle-check"></i>
                @if(this.plan?.minAge <= 0 && this.plan?.maxAge >= 99){
                <h4>ບໍ່ຈຳກັດອາຍຸ</h4>
                }@else { @if(this.products?.ageCoverage){
                <h4>{{ this.products?.ageCoverage }}</h4>
                }@else {
                <h4>-----</h4>
                } }

                <!-- <h4>1 - 55</h4> -->
              </div>
            </div>
            <div class="box">
              <h6>{{ 'PRODUCT_PLAN_DETAIL.COVERAGE_PERIOD' | translate }}</h6>
              <div class="content">
                <i class="fa-solid fa-circle-check"></i>
                <h4>
                  @if(this.products?.coverageYear > 0){
                  {{ this.products?.coverageYear }} {{ 'PRODUCT_PLAN_DETAIL.YEARS' | translate }} }@else if(!this.products?.coverageYear){
                  {{ 'PRODUCT_PLAN_DETAIL.LIFETIME' | translate }} }@else { ----- }
                  <span class="payment-note">
                    @if(this.products?.paymentYear < this.products?.coverageYear){ ({{ 'PRODUCT_PLAN_DETAIL.PAY_ONLY' | translate }}
                    {{ this.products?.paymentYear }} {{ 'PRODUCT_PLAN_DETAIL.YEARS' | translate }}) }
                  </span>
                </h4>
              </div>
            </div>
          </div>

          <div class="mini-card single">
            <div class="box">
              <h6>{{ 'PRODUCT_PLAN_DETAIL.PAYMENT_METHOD' | translate }}</h6>
              <div class="parent-content">
                <div class="content" *ngFor="let paymentTerm of this.products?.paymentTerms">
                  <i class="fa-solid fa-sack-dollar"></i>
                  <h4>{{ paymentTerm.term }}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="section-plan-detail">
        <h1>{{ 'PRODUCT_PLAN_DETAIL.BENEFITS' | translate }}</h1>
        <cdk-accordion class="example-accordion width-box">
          @for (item of items; track item; let index = $index) {
          <cdk-accordion-item #accordionItem="cdkAccordionItem" class="example-accordion-item">
            <button
              class="example-accordion-item-header"
              (click)="accordionItem.toggle(); this.height == false ? heightOp() : heightCl()"
              tabindex="0"
              [attr.id]="'accordion-header-' + index"
              [attr.aria-expanded]="accordionItem.expanded"
              [attr.aria-controls]="'accordion-body-' + index"
            >
              {{ 'PRODUCT_PLAN_DETAIL.DETAILS' | translate }}
              <span class="example-accordion-item-description">
                @if( accordionItem.expanded ){
                <div><i class="fa-solid fa-caret-up"></i></div>
                }@else{
                <div class="icon-rotated"><i class="fa-solid fa-caret-up"></i></div>
                }
              </span>
            </button>
            @if(accordionItem.expanded) {
            <div
              class="example-accordion-item-body"
              role="region"
              [style.display]="accordionItem.expanded ? '' : 'none'"
              [attr.id]="'accordion-body-' + index"
              [attr.aria-labelledby]="'accordion-header-' + index"
            >
              <ol class="benefits-list">
                <li *ngFor="let productCoverage of this.products?.productCoverages">
                  {{ productCoverage.name }}
                </li>
              </ol>
            </div>
            }
          </cdk-accordion-item>
          }
        </cdk-accordion>

        @if(this.height){
        <div id="target"></div>
        }
      </section>
    </mat-tab>
    <mat-tab label="{{ 'PRODUCT_PLAN_DETAIL.TAB_CALCULATE_PREMIUM' | translate }}">
      <div class="width-box calculator-container">
        <ng-template mat-tab-label>
          <i class="fa-solid fa-calculator"></i>
          <p>{{ 'PRODUCT_PLAN_DETAIL.TAB_CALCULATE_PREMIUM' | translate }}</p>
        </ng-template>
        <div class="row mb-3 mt-3">
          <div class="col-sm-6" *ngIf="!shouldHideCoverageAmount">
            <label class="mb-2 la-font">{{ 'PRODUCT_PLAN_DETAIL.COVERAGE_AMOUNT' | translate }}<span class="form-required">*</span></label>

            <mat-form-field appearance="outline" class="form-field-full-width">
              <mat-select
                [value]="this.productOptions[0]?.id"
                (selectionChange)="handleProductOptionChange($event.value)"
              >
                <mat-option *ngFor="let option of productOptions" [value]="option.id">
                  {{ option.amount | number }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="{{ !shouldHideCoverageAmount ? 'col-sm-6' : 'col-sm-12' }}">
            <label class="mb-2 la-font">{{ 'PRODUCT_PLAN_DETAIL.PAYMENT_PERIOD' | translate }}<span class="form-required">*</span></label>
            <mat-form-field appearance="outline" class="form-field-full-width">
              <mat-select
                [value]="this.paymentTerms[0]?.termId"
                (selectionChange)="handleProductTermChange($event.value)"
              >
                <mat-option *ngFor="let term of paymentTerms" [value]="term.termId">
                  {{ term.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <section class="section-plan-detail">
          <div class="big-card width-box">
            <div class="mini-card third">
              <div class="box">
                <h6>{{ 'PRODUCT_PLAN_DETAIL.PREMIUM_PER_PERIOD' | translate }}</h6>
                <div class="content">
                  <img class="currency-icon-small" src="../../../assets/images/kip_S.png" alt="Kip" />
                  <h4>{{ this?.updatePremiumAmtPerTime | number }}</h4>
                </div>
              </div>
              <div class="box">
                <h6>{{ 'PRODUCT_PLAN_DETAIL.PREMIUM_PER_YEAR' | translate }}</h6>
                <div class="content">
                  <img class="currency-icon-small" src="../../../assets/images/kip_S.png" alt="Kip" />
                  <h4>{{ this?.updatePremiumAmtPerYear | number }}</h4>
                </div>
              </div>

              <div class="box">
                <h6 class="total-premium-label">{{ 'PRODUCT_PLAN_DETAIL.TOTAL_PREMIUM_AMOUNT' | translate }}</h6>
                <div class="content">
                  <img class="currency-icon-small" src="../../../assets/images/kip.png" alt="Kip" />
                  <h4 class="total-premium-amount">{{ this?.updateTotalPremiumAmt | number }}</h4>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </mat-tab>
  </mat-tab-group>
  <button
    [routerLink]="['/application-create']"
    [queryParams]="{ productId: this.productId, planId: this.planId }"
    matFab
    extended
    class="la-font"
    style="right: 30px; bottom: 30px;">
    <i class="fa-solid fa-comment-dollar fab-icon"></i>
    {{ 'PRODUCT_PLAN_DETAIL.SELL' | translate }}
  </button>
</div>
